module.exports = __webpack_public_path__ + "static/media/71P0C5P3iDL._AC_SL1500_.9f9a2bd5.jpg";